import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileUpload from '../Common/FormsyFileUpload';
import Form from '../Common/Form.react';
import ModuleImportStore from '../../stores/ModuleImportStore';
import ModuleImportActions from '../../actions/ModuleImportActionCreator';
import { Container } from 'flux/utils';
import { CardText, CardTitle } from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import { Link } from 'react-router';

class ModuleImportForm extends Component {

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onError = this.onError.bind(this);
    }

    onChange(fileUploadName, targetFile = {}) {
        ModuleImportActions.setTargetFile(targetFile);
    }

    onSave(formData) {
        if (!formData[this.props.fileUploadName]) {
            return ModuleImportActions.emitError('Please select file to upload');
        }
        if (!this.props.allowedTypes.includes(formData[this.props.fileUploadName].type)) {
            return ModuleImportActions.emitError('Please select a valid CSV file');
        }
        ModuleImportActions.importModule(formData);
    }

    onError(lastErrorMessage) {
        ModuleImportActions.emitError(lastErrorMessage);
    }

    render() {

        const errors = this.state.data.errors.map((error, index) => <li key={index}>{error}</li>);
        const warnings = this.state.data.warnings.map((warning, index) => <li key={index}>{warning}</li>);
        const errorsList = !!errors.length ? <ul>{errors}</ul> : null;
        const warningsList = !!warnings.length ? <ul>{warnings}</ul> : null;
    	
        return (
            <div>
                <Form suppressRedirect={this.props.suppressRedirect} title={this.props.title} onSave={this.onSave} onError={this.onError}>
                    <CardTitle
                        title='Import modules from CSV'
                        subtitle='File must include the column headings in the first row.'
                    />
                    <CardText>
                    <p>Your column headings should match the onles listed below</p>
                    <ul>
                    <li>name *required</li>
                    <li>code *required</li>
                    <li>version *required</li>
                    <li>description</li>
                    <li>validFrom *required [YYYY/MM/DD]</li>
                    <li>type [classroom,resource,video,e-learning]</li>
                    <li>visibility [private, public]</li>
                    </ul>
                        <p><Link to="/training/module/import/template" download="modules.csv" target="_blank">Download template</Link></p>
                    </CardText>
                    <FileUpload name={this.props.fileUploadName} required onChange={this.onChange}/>
                </Form>
                <Dialog
                    title="Results"
                    open={this.state.isProcessed}
                    onRequestClose={() => ModuleImportActions.setProcessed(false)}
                    autoScrollBodyContent={true}
                >
                    <p>Number of rows added: {this.state.data.successCount}</p>
                    <p>Number of rows skipped: {this.state.data.totalProcessedCount - this.state.data.successCount}</p>
                    <p>Total rows processed: {this.state.data.totalProcessedCount}</p>
                    <p>Errors: {errors.length}</p>
                    {errorsList}
                    <p>Warnings: {warnings.length}</p>
                    {warningsList}
                </Dialog>
            </div>
        );
    }

}

ModuleImportForm.propTypes = {
    title: PropTypes.string,
    fileUploadName: PropTypes.string,
    allowedTypes: PropTypes.arrayOf(PropTypes.string),
};
ModuleImportForm.defaultProps = {
    title: 'Import modules',
    fileUploadName: 'import',
    allowedTypes: ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    suppressRedirect: true,
};
ModuleImportForm.getStores = () => ([ModuleImportStore]);
ModuleImportForm.calculateState = () => ModuleImportStore.getState();

export default Container.create(ModuleImportForm, {withProps: true});
